import emotorbike from '../../images/gallerium/onDemand/emotorbike.png'
import graphene from '../../images/gallerium/onDemand/graphene.png'
import hyper from '../../images/gallerium/onDemand/hyper.png'
import mett from '../../images/gallerium/onDemand/mett.png'
import navi from '../../images/gallerium/onDemand/navi.png'
import nlep from '../../images/gallerium/onDemand/nlep.png'
import surf from '../../images/gallerium/onDemand/surf.png'
import what from '../../images/gallerium/onDemand/what.png'
import iont from '../../images/gallerium/onDemand/iont.png'
import { onDemandVideosType } from './videos'

export interface onDemandCategoryType {
  id: string
  categoryName?: string
  thumbnail: string
  destination: string
  videos?: Array<onDemandVideosType>
  type?: string
  title?: string
}

const onDemandCategories: Array<onDemandCategoryType> = [
  {
    id: 'video-01',
    type: 'video',
    thumbnail: emotorbike,
    destination: '617708222',
    title: 'E-Motorbike-Nanostructured Batteries and Monitoring System',
  },
  {
    id: 'video-02',
    type: 'video',
    thumbnail: graphene,
    destination: '617708581',
    title: 'Graphene Based Portable Energy Storage',
  },
  {
    id: 'video-03',
    type: 'video',
    thumbnail: hyper,
    destination: '617708820',
    title: 'HyPER- hydrogen paired electric racecar',
  },
  {
    id: 'video-04',
    type: 'video',
    thumbnail: mett,
    destination: '617709614',
    title: 'METT-Nanotech based Wireless Charger',
  },
  {
    id: 'video-05',
    type: 'video',
    thumbnail: navi,
    destination: '617709720',
    title: 'NAVi-NanoMalaysia Autonomous Vehicles Initiative',
  },
  {
    id: 'video-06',
    type: 'video',
    thumbnail: nlep,
    destination: '617710832',
    title: 'NLEP-Nanolight Energy Panel',
  },
  {
    id: 'video-07',
    type: 'video',
    thumbnail: surf,
    destination: '617711385',
    title: 'SURF-Smart Urban Farming',
  },
  {
    id: 'video-08',
    type: 'video',
    thumbnail: what,
    destination: '625106364',
    title: 'ML Studio-Apa itu Nanoteknologi? ',
  },
  {
    id: 'video-09',
    type: 'video',
    thumbnail: iont,
    destination: '626006778',
    title: 'IoNT-equipped drones powered by onboard generator hydrogen fuel cell',
  },
]

export { onDemandCategories }
